var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "orderCollectionOfFeesFormObserver",
    attrs: { tag: "div" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ handleSubmit }) {
          return [
            _c(
              "form",
              {
                staticClass: "agreement-item",
                class: { "is-waiting": _vm.isWaiting },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.putPayAgreement)
                  },
                },
              },
              [
                _c("b", { staticClass: "agreement-name" }, [
                  _vm._v("Umowa za zawody: " + _vm._s(_vm.agreement.name)),
                ]),
                _c(
                  "div",
                  { staticClass: "agreement-date" },
                  [
                    _c(
                      "base-button",
                      {
                        attrs: {
                          btn9: "",
                          icon: "dsi dsi-download",
                          loading: _vm.isWaiting,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.payAgreementLink(_vm.agreement.id)
                          },
                        },
                      },
                      [_c("span", [_vm._v("Pobierz wzór umowy")])]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "agreement-actions" },
                  [
                    _c("ValidationProvider", {
                      staticClass: "scroll-margin",
                      attrs: { name: "file", rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors }) {
                              return [
                                _c("base-input-file", {
                                  class: {
                                    "is-error": errors[0],
                                  },
                                  attrs: {
                                    accept: "image/*,.pdf",
                                    isMultiple: false,
                                    converter: "base64",
                                    hint: "Wybierz plik",
                                  },
                                  model: {
                                    value: _vm.file,
                                    callback: function ($$v) {
                                      _vm.file = $$v
                                    },
                                    expression: "file",
                                  },
                                }),
                                errors[0]
                                  ? _c(
                                      "span",
                                      { staticClass: "input-error-alt" },
                                      [_vm._v("Pole wymagane")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c(
                      "base-button",
                      {
                        attrs: { btn1: "", short: "" },
                        on: {
                          click: function ($event) {
                            return handleSubmit(_vm.putPayAgreement)
                          },
                        },
                      },
                      [_c("span", [_vm._v("AKCEPTUJĘ")])]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }